module.exports = __webpack_public_path__ + "img/dennis-birthday-cake.0754e820.jpg";